import { useEffect } from "react";
import { useHistory } from "react-router-dom";

import { FullscreenLoading } from "../../components/FullscreenLoading";
import { clearLocalSession } from "../../utils/session";

export const LogoutCallback = () => {
  const history = useHistory();

  useEffect(() => {
    clearLocalSession();
    history.push("/login");
  }, [history]);

  return <FullscreenLoading isVisible />;
};
